'use client';

import { useState } from 'react';
import { subscribeToNewsletter } from '@/components/integrations/Actions';
import elevarSubscribe from '@/lib/elevar/subscribe';
import CTAButton from '@/components/elements/CTAButton';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const SubscribeForm = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!EMAIL_REGEX.test(email)) {
      setStatus('error');
      setMessage('Please enter a valid email address.');
      return;
    }

    setStatus('loading');

    try {
      const result = await subscribeToNewsletter(email);

      if (result.success) {
        elevarSubscribe(email);
        setEmail('');
        setStatus('success');
        setMessage("Thanks! You've been subscribed.");
      } else {
        throw new Error('Subscription failed');
      }
    } catch {
      setStatus('error');
      setMessage('Something went wrong. Please try again.');
    }
  };

  if (status === 'success') {
    return <p className="mt-4 text-sm text-white/80">{message}</p>;
  }

  return (
    <form onSubmit={handleSubmit} className="mt-4" aria-labelledby="subscribe-heading">
      <label htmlFor="subscribe-email" className="sr-only">Email address</label>
      <input
        id="subscribe-email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        required
        className="w-full px-4 py-2 text-gray-900 bg-white border border-white/30 rounded-full text-sm"
      />
      <CTAButton
        type="submit"
        disabled={status === 'loading'}
        className="w-full mt-2 px-4 py-2 font-normal text-lg"
      >
        {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
      </CTAButton>
      {status === 'error' && (
        <p className="mt-2 text-lg text-red-300">{message}</p>
      )}
    </form>
  );
};

export default SubscribeForm;
